import React from 'react'

import { ImageProps } from '/lib/modules/image/index.d';

import ImageBlock from '/react4xp/components/ImageBlock';

function ImagePart(props: ImageProps) {
    return (
        <ImageBlock {...props} />
    )
}

export default (props) => <ImagePart {...props} /> 
